import { title } from "process"
import { AccordionView } from "../../common/accordion/accordion.view"
import { IAccordionData } from "../../common/interfaces/accordionData"
import { IWaterMeterPoint } from "../../Types/WaterMeterTypes"
import { parseDateToString } from "../../common/utilities/parser"
import { Table } from "react-bootstrap"

type WaterMeterPointProps = {
    point: IWaterMeterPoint,
}

const WaterMeterPoint = (props: WaterMeterPointProps) => {


    function createAccordionData(point: IWaterMeterPoint): IAccordionData[] {
        let accordionData: { title: string; content: JSX.Element }[] = [];

        point.waterMeters.map(waterMeter => {
            const orderedReadings = [...waterMeter.waterMeterReadings].sort(
                (a,b) => new Date(b.readingDate).getTime() - new Date(a.readingDate).getTime()
            )
            accordionData.push({
                title: point.placement + " - " + waterMeter.serialNo,
                content: (<>
                <Table striped hover size="sm" responsive borderless>
                    <tbody>
                    <tr>
                        <td>Serienummer</td>
                        <td>{waterMeter.serialNo}</td>
                    </tr>
                    <tr>
                        <td>Montert</td>
                        <td>{parseDateToString(waterMeter.attachmentDate)}</td>
                    </tr>
                    <tr>
                        <td>Kalkulert årlig forbruk</td>
                        <td>{waterMeter.calculatedYearlyConsumption} m<sup>3</sup></td>
                    </tr>
                    <tr>
                        <td>Siste avlesning ({parseDateToString(orderedReadings[0].readingDate)})</td>
                        <td>{orderedReadings[0].reading} m<sup>3</sup></td>
                    </tr>
                    <tr>
                        <td>Automatisk avlesning: </td>
                        <td>{waterMeter.automaticMeter ? "Ja" : "Nei" }</td>
                    </tr>
                    <tr>
                        <td>Plassering</td>
                        <td>{point.placement}</td>
                    </tr>
                    </tbody>
                </Table>
                <h2>Avlesninger</h2>
                <Table striped hover size="sm" responsive borderless>
                    <thead className="tableHeader">
                        <tr>
                            <th>Dato</th>
                            <th>Avlest målerstand</th>
                            <th>Forbruk siden forrige avlesning</th>
                            <th>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderedReadings.filter(r => r.consumption > 0).map(reading => {
                            return (
                            <tr>
                                <td>{parseDateToString(reading.readingDate)}</td>
                                <td>{reading.reading} m<sup>3</sup></td>
                                <td>{reading.consumption} m<sup>3</sup></td>
                                <td>{reading.readingFormDescription}</td>
                            </tr>
                            )
                        })}
                    </tbody>
                </Table> 
                </>)
            })
        })
        return accordionData;
    }

    return <AccordionView showNarrow={true} isActive={true} content={createAccordionData(props.point)} />
}

export default WaterMeterPoint